import { createAction } from 'redux-actions';

import types from './types';

const getPaymentMethods = createAction(types.GET_PAYMENT_METHODS);
const setPaymentMethods = createAction(types.SET_PAYMENT_METHODS);
const setIsPaymentPage = createAction(types.SET_IS_PAYMENT_PAGE);
const resetPaymentPageData = createAction(types.RESET_PAYMENT_PAGE_DATA);
const setOrderApiError = createAction(types.SET_ORDER_API_ERROR);
const getSavedCards = createAction(types.GET_SAVED_CARDS);
const setSavedCards = createAction(types.SET_SAVED_CARDS);
const setSaveCardUsed = createAction(types.SET_SAVE_CARD_USED);
const setSavedCardsAvailable = createAction(types.SET_SAVED_CARDS_AVAILABLE);

const getSelectedCard = createAction(types.GET_SELECTED_CARD);
const setSelectedCard = createAction(types.SET_SELECTED_CARD);
const setSaveCardFlag = createAction(types.SET_SAVE_CARD_FLAG);
const payNowActive = createAction(types.SET_PAY_NOW_ACTIVE);
const resetCardSelection = createAction(types.RESET_CARD_SELECTION);
const setCardHolderName = createAction(types.SET_CARD_HOLDER_NAME);
const fetchIFrameURL = createAction(types.FETCH_IFRAME_URL);
const setIframeUrl = createAction(types.SET_IFRAME_URL);
const setPaymentMethod = createAction(types.SET_PAYMENT_METHOD);
const resetPaymentMethod = createAction(types.RESET_PAYMENT_METHOD);
const setTokenizationAllowed = createAction(types.SET_TOKENIZATION_ALLOWED);
const placeOrder = createAction(types.PLACE_ORDER);
const setPaymentAvailability = createAction(types.SET_PAYMENT_AVAILABILITY);
const setTerms = createAction(types.SET_TERMS);
const setPayWithLoyaltyPointsMethodExtraInfo = createAction(
    types.SET_PAY_WITH_LOYALTY_POINTS_METHOD,
);
const payWithLoyaltyPoints = createAction(types.PAY_WITH_LOYALTY_POINTS);
const setError = createAction(types.SET_ERROR, (name, value = true) => ({
    name,
    value,
}));
const resetErrors = createAction(types.RESET_ERRORS);
const setTermsAccepted = createAction(types.SET_TERMS_ACCEPTED);
const setLoading = createAction(types.SET_LOADING);
const setCartNotFound = createAction(types.SET_CART_NOT_FOUND);
const openRemoveCardDialog = createAction(types.OPEN_REMOVE_CARD_DIALOG);
const setRemoveCard = createAction(types.SET_REMOVE_CARD);
const setRemoveCardReset = createAction(types.SET_REMOVE_CARD_RESET);
const setCardSaveSuccess = createAction(types.SET_CARD_SAVE_SUCCESS);
const removeSelectedCard = createAction(types.REMOVE_SELECTED_CARD);
const fetchMonetaWebIFrameURL = createAction(types.FETCH_MONETAWEB_IFRAME_URL);
const getGiftCardMethods = createAction(types.GET_GIFT_CARD_METHODS);
const setGiftCardMethods = createAction(types.SET_GIFT_CARD_METHODS);
const paymentMethodSet = createAction(types.PAYMENT_METHOD_SET);
const resetSopData = createAction(types.RESET_SOP_DATA);
const setIsNewOrderApiEnabled = createAction(types.SET_IS_NEW_ORDER_API_ENABLED);
const updatePaymentSession = createAction(types.UPDATE_PAYMENT_SESSION);
const clearPaymentSession = createAction(types.CLEAR_PAYMENT_SESSION);
const setPaymentSession = createAction(types.SET_PAYMENT_SESSION);
const setPaymentSessionDeliveryLine = createAction(types.SET_PAYMENT_SESSION_DELIVERY_LINE);
const setPaymentSessionAuthorized = createAction(types.SET_PAYMENT_SESSION_AUTHORIZED);
const loadKlarnaApi = createAction(types.LOAD_KLARNA_API);
const getPayWithLoyaltyPoints = createAction(types.GET_PAY_WITH_LOYALTY_POINTS_METHOD);
const placeSwipeToBuyOrder = createAction(types.PLACE_ORDER_SWIPE_TO_BUY);
const resetRequiredCheck = createAction(types.RESET_REQUIRED_CHECK);

export default {
    getPaymentMethods,
    setPaymentMethods,
    setIsPaymentPage,
    setCartNotFound,
    resetPaymentPageData,
    getPayWithLoyaltyPoints,
    resetCardSelection,
    setPaymentMethod,
    resetPaymentMethod,
    setTokenizationAllowed,
    getSavedCards,
    setSaveCardFlag,
    payNowActive,
    setCardHolderName,
    getSelectedCard,
    setSelectedCard,
    fetchIFrameURL,
    setIframeUrl,
    setSavedCards,
    fetchMonetaWebIFrameURL,
    setOrderApiError,
    setSavedCardsAvailable,
    setPaymentAvailability,
    setTerms,
    setPayWithLoyaltyPointsMethodExtraInfo,
    payWithLoyaltyPoints,
    placeOrder,
    setError,
    resetErrors,
    setTermsAccepted,
    setLoading,
    openRemoveCardDialog,
    setRemoveCard,
    setRemoveCardReset,
    setCardSaveSuccess,
    removeSelectedCard,
    setSaveCardUsed,
    getGiftCardMethods,
    setGiftCardMethods,
    paymentMethodSet,
    resetSopData,
    setIsNewOrderApiEnabled,
    updatePaymentSession,
    clearPaymentSession,
    setPaymentSession,
    setPaymentSessionDeliveryLine,
    setPaymentSessionAuthorized,
    loadKlarnaApi,
    placeSwipeToBuyOrder,
    resetRequiredCheck,
};
